var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-of-materials-item",class:{
    'material-demanded': _vm.isThisMaterialDemanded,
    'material-required': _vm.isThisMaterialRequired,
    'material-requirement-satisfied': _vm.isThisMaterialRequirementSatisfied
  }},[_c('label',{attrs:{"for":'inventory-'+_vm.material.name}},[_vm._v(_vm._s(_vm.material.name))]),_c('el-input-number',{attrs:{"controls":false,"id":'inventory-'+_vm.material.name,"min":0},model:{value:(_vm.inventoryQuantity),callback:function ($$v) {_vm.inventoryQuantity=$$v},expression:"inventoryQuantity"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }